<!-- content start -->
<div class="content-grey" [formGroup]="periodicReportForm">

  <div class="d-flex justify-content-center align-items-center">
    <p-progressSpinner *ngIf="loading" styleClass="w-4rem h-4rem" strokeWidth="8" fill="var(--surface-ground)"
      animationDuration=".5s"></p-progressSpinner>
  </div>

  <div class="row p-0" *ngIf="!loading">

    <div class="col-lg-12 col-md-6 col-12" *ngIf="report?.ou && mode !== 'create'">
      <div class="d-flex align-items-center">
        <div class="tab-profile">
          <img *ngIf="checkisImg(report.ou?.image); else elseBlock" src="{{ staticURL }}{{ report.ou?.image }}"
            class="tab-profile-img" style="max-height: 30px; max-width: 30px" />
          <ng-template #elseBlock>
            <i class="{{ report.ou?.image }} p-2" style="font-size: 1rem"></i>
          </ng-template>
        </div>
        <h5 class="">
          {{report?.ou?.name}}
        </h5>
      </div>
    </div>


    <ng-container *ngIf="mode !== 'Manager' || hasPermission('PERIODIC_REPORTS', 'u')">
      <div class="col-lg-6 col-md-6 col-12">
        <div class="d-flex flex-column">
          <div class="d-flex my-2">
            <img class="filter-brightness" src="../../../../assets/icones-2025/apartment.png" alt="loading">
            <label class="label-ui">{{'Organizational unit'|translator}}</label>
          </div>
          <div>
            <p-treeSelect class="pppp-tree" containerStyleClass="pppp-tree w-100"
              [disabled]="isManagerMode || mode !== 'create'" [options]="selectedTreeData" appendTo="body"
              formControlName="ou" (ngModelChange)="getContentUpdates()"
              placeholder="{{ 'Choose the organizational unit' | translator }}" [filter]="true"
              [filterInputAutoFocus]="true">
              <ng-template let-node pTemplate="default">
                <div class="d-flex">
                  <img *ngIf="checkisImg(node.data); else elseBlock" src="{{ staticURL }}{{ node.data }}"
                    class="img-fluid p-1 tree-img-bg" style="max-height: 30px; max-width: 30px" />
                  <ng-template #elseBlock>
                    <i class="{{ node.data }} p-2" style="font-size: 1rem"></i>
                  </ng-template>
                  <b class="text-nowrap">{{ node.label }}</b>
                </div>
              </ng-template>
            </p-treeSelect>
          </div>
        </div>

      </div>
      <div *ngIf="mode !== 'create' && periodicReportForm.get('manager')?.value" class="col-lg-6 col-md-6 col-12">
        <div class="d-flex flex-column">
          <div class="d-flex my-2">
            <img class="filter-brightness" src="../../../../assets/icones-2025/person_2.png" alt="loading">
            <label class="label-ui">{{"Manager" | translator}}</label>
          </div>
          <div>
            <div class="d-flex align-items-center">
              <div class="tab-grey-box-2">
                <div>{{periodicReportForm.get('manager')?.value?.name}}</div>
              </div>
              <!-- <div class="plus-btn ms-2" (click)="periodicReportForm.get('manager')?.setValue(null)">
                <i class="pi pi-times"></i>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="mode == 'create'" class="col-lg-6 col-md-6 col-12">
        <div class="d-flex flex-column">
          <div class="d-flex my-2">
            <img class="filter-brightness" src="../../../../assets/icones-2025/calendar_today.png" alt="loading">
            <label class="label-ui">{{"Report Form" | translator}}</label>
          </div>
          <div class="d-flex align-items-center justify-content-start">
            <div class="w-100">
              <p-calendar class="ppp-calendar-- w-100" appendTo="body" (onSelect)="periodicReportForm.get('reportForm')?.setValue($event);getContentUpdates()"  dir="ltr" [showIcon]="false" [maxDate]="currentDate" >
                <ng-template pTemplate="date" let-date>
                  <span
                    [ngStyle]="{
                      textDecoration: disableDates(date)
                        ? 'line-through'
                        : 'inherit'
                    }"
                    >{{ date.day }}</span
                  >
                </ng-template>
              </p-calendar>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-6 col-12">
        <div class="d-flex flex-column">
          <div class="d-flex my-2">
            <img class="filter-brightness" src="../../../../assets/icones-2025/calendar_today.png" alt="loading">
            <label class="label-ui">{{"After Number of days" | translator}}</label>
          </div>
          <input type="number" id="days" formControlName="days" pInputText>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <div class="d-flex flex-column">
          <div class="d-flex my-2">
            <img class="filter-brightness" src="../../../../assets/icones-2025/schedule.png" alt="loading">
            <label class="label-ui">{{"time" | translator}}</label>
          </div>
          <p-calendar class="ppp-calendar--" dir="ltr" [showIcon]="false" formControlName="time" [showTime]="true"
            [hourFormat]="'12'" [timeOnly]="true" [showSeconds]="false" [stepMinute]="60"></p-calendar>
        </div>
      </div>

    </ng-container>

    <div class="col-lg-6 col-md-6 col-12">
      <div class="d-flex flex-column">
        <div class="d-flex my-2">
          <img class="filter-brightness" src="../../../../assets/icones-2025/calendar_today.png" alt="loading">
          <label class="label-ui">{{"Next Report Date" | translator}}</label>
        </div>
        <div class="d-flex">
          <div class="tab-white-box">
            <div class="inner-data-border">
              <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today-(2).png" alt="loading">
              <div>{{ enhancedDate ? (enhancedDate | date:'MMM - dd -yyyy') : (currentDate | date:'MMM - dd -yyyy') }}
              </div>
            </div>
            <div class="inner-data">
              <img class="tab-icone" src="../../../../assets/icones-2025/schedule.png" alt="loading">
              <div>{{ periodicReportForm.get('time')?.value ? (periodicReportForm.get('time')?.value | date:'shortTime')
                : (currentDate | date:'shortTime') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="mode !== 'create'" class="col-lg-6 col-md-6 col-12 d-flex align-items-center">
      <div class="d-flex flex-column w-100">
        <div class="d-flex my-2">
          <img class="filter-brightness" src="../../../../assets/icones-2025/calendar_today.png" alt="loading">
          <label class="label-ui">{{"Report Form" | translator}}</label>
        </div>
        <div class="d-flex align-items-center">
        <div class="tab-grey-box-modal">
          <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today-(2).png" alt="loading">
          <div>{{report?.reportForm !== 'New Report form started' ? (report.reportForm | date:'dd-MM-yyyy') :
            report.reportForm | translator}}</div>
        </div>
      <div class="tab-arrow mx-2">
        <img class="tab-icone" src="../../../../assets/icones-2025/arrow_cool_down.png" alt="loading">
      </div>

      <div class="tab-grey-box-modal">
        <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today-(2).png" alt="loading">
        <div>{{report?.reportTo | date:'dd-MM-yyyy'}}</div>
      </div>
      </div>
    </div>
    </div>
    <div class="content-white" *ngIf="!loading && contentUpdateData.length > 0 && status !== 'NO_DATA'">
      <ng-container *ngFor="let type of contentUpdateData">
        <div class="d-flex align-items-center my-3">
          <div class="d-flex">
            <div class="plus-btn">
              <img class="" src="../../../../assets/icones-2025/add.png" alt="loading">
            </div>
          </div>
          <div class="d-flex">
            <p class="text">{{ type.type !== 'OU CHANGE' ? 'تم ' + (type.type | translator) : (type.type | translator)}}
            </p>
          </div>
          <div class="custom-hr"></div>
        </div>
        <div class="d-flex flex-wrap">
          <div *ngFor="let item of type.data" class="blue-num-btn">
            <div class="d-flex">
              <div class="btn-num">
                {{ item.count }}
              </div>
            </div>
            <div class="d-flex align-items-center mx-2">
              <img class="" src="../../../../assets/icones-2025/draft.png" alt="loading">
            </div>
            <div class="d-flex">
              <label class="cursor">{{ item._id | translator}}</label>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <app-no-data *ngIf="status == 'NO_DATA'"></app-no-data>

    <ng-container *ngIf="((status !== 'PENDING'  || mode == 'Manager') && mode !== 'create' && status !== 'NO_DATA') && !loading">
      <div class="content-white">
        <p class="text-300">{{'Have all the organization data been reviewed on the knowledge portal?'|translator}}</p>
        <div class="d-flex">
          <div [class]="periodicReportForm.get('confirmation')?.value === true ? 'yes-btn active' : 'no-btn'"
            (click)="report.status !== 'SIGNED' ? periodicReportForm.patchValue({confirmation: true}) : null">
            <div class="d-flex">
              <label class="cursor">{{'Yes'|translator}}</label>
            </div>
          </div>
          <div [class]="periodicReportForm.get('confirmation')?.value === false ? 'yes-btn active' : 'no-btn'"
            (click)="report.status !== 'SIGNED' ? periodicReportForm.patchValue({confirmation: false}) : null">
            <div class="d-flex">
              <label class="cursor">{{'No'|translator}}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="content-white">
        <p class="text-300">{{'Please add comments'|translator}}</p>
        <div class="form-floating">
          <textarea class="form-control custom-textarea" formControlName="comment" placeholder="Leave a comment here"
            id="floatingTextarea2" style="height: 100px"></textarea>
        </div>
      </div>
      <div class="content-white">
        <p class="text-300">{{'Please confirm'|translator}}</p>
        <div class="text-radio-bar">
          <div class="d-flex">
            <input class="form-check-input cursor-pointer" type="checkbox"  formControlName="agreement" name="agreement">
          </div>{{'I agree to the terms and conditions'|translator}}
        </div>
      </div>
    </ng-container>
    <div class="d-flex" *ngIf="!loading">
      <div class="submit-blue-btn" (click)="submitForm()">
        <div class="d-flex align-items-center">
          <img class="" src="../../../../assets/icones-2025/check_small.png" alt="loading">
        </div>
        {{ (report?.status !== 'SIGNED' ? 'Submit' : 'Close') | translator}}
      </div>
    </div>
  </div>
  <!-- content end -->